import { memo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-google-color-large.tsx
/**
* icon.24.logo.google.color.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ViNDMzNSIgZD0iTTEyIDNjMi4zNjUgMCA0LjUxNS45MTMgNi4xMiAyLjQwNGwtMi40ODcgMi40MjFBNS41NCA1LjU0IDAgMCAwIDYuODEgMTAuMDdMNC4wMTggNy44NDJBOSA5IDAgMCAxIDEyLjAwMSAzIi8+PHBhdGggZmlsbD0iI2ZiYmMwNSIgZD0iTTYuODA5IDEwLjA3MWE1LjUgNS41IDAgMCAwLS4zNDQgMS45MjVjMCAuNjk0LjEyOCAxLjM1OC4zNjEgMS45N2wtMi44MzQgMi4xMzhBOC45NiA4Ljk2IDAgMCAxIDMgMTEuOTk2YTguOTUgOC45NSAwIDAgMSAxLjAxNi00LjE1MnoiLz48cGF0aCBmaWxsPSIjMzRhODUzIiBkPSJNNi44MjMgMTMuOTZhNS41MzcgNS41MzcgMCAwIDAgOC4zNDEgMi41OGwyLjc3NSAyLjIxOWE4Ljk5NyA4Ljk5NyAwIDAgMS0xMy45NS0yLjY2eiIvPjxwYXRoIGZpbGw9IiM0Mjg1ZjQiIGQ9Ik0yMC44NDQgMTAuMzI4YTguOTggOC45OCAwIDAgMS0yLjkxMyA4LjQyOWwtMi43NzUtMi4yMTlhNS41NSA1LjU1IDAgMCAwIDIuMTIzLTIuODc2SDEyLjE4di0zLjMzaDUuMTAybC0uMDAxLS4wMDR6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=24953-60641
*/
const Icon24LogoGoogleColorLarge = memo(function Icon24LogoGoogleColorLarge(props) {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: "#eb4335",
				d: "M12 3c2.365 0 4.515.913 6.12 2.404l-2.487 2.421A5.54 5.54 0 0 0 6.81 10.07L4.018 7.842A9 9 0 0 1 12.001 3"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#fbbc05",
				d: "M6.809 10.071a5.5 5.5 0 0 0-.344 1.925c0 .694.128 1.358.361 1.97l-2.834 2.138A8.96 8.96 0 0 1 3 11.996a8.95 8.95 0 0 1 1.016-4.152z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#34a853",
				d: "M6.823 13.96a5.537 5.537 0 0 0 8.341 2.58l2.775 2.219a8.997 8.997 0 0 1-13.95-2.66z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#4285f4",
				d: "M20.844 10.328a8.98 8.98 0 0 1-2.913 8.429l-2.775-2.219a5.55 5.55 0 0 0 2.123-2.876H12.18v-3.33h5.102l-.001-.004z"
			})
		]
	});
});
//#endregion
export { Icon24LogoGoogleColorLarge };

//# sourceMappingURL=icon-24-logo-google-color-large.js.map